import { createSelectors } from "@/redux/helpers/selector";

import { MODULE } from "./constants";

export const [getSaved, getIsLoaded] = createSelectors(MODULE, ["saved", "isLoaded"]);
